import { sheetDataState as initialState } from './sheetData.initialState';
import { createSlice } from '@reduxjs/toolkit';

const sheetDataSlice = createSlice({
  name: 'SheetData',
  initialState,
  reducers: {
    //* this hold all data which is loaded from the mf files api or by opening the file
    setSheetMemoryData: (state, action) => {
      const { sheetName, sheetData, sheetIndex, sheetId } = action.payload;
      // Find the sheet based on its unique sheetId.
      const existingSheetIndex = state.sheetMemoryData.findIndex(
        (sheet) => sheet.sheetId === sheetId
      );

      // If the sheet already exists, merge/update the rows.
      if (existingSheetIndex !== -1) {
        const existingSheet = state.sheetMemoryData[existingSheetIndex];

        // Loop through each row in the incoming sheetData
        sheetData.forEach((newRow, rowIndex) => {
          // If an existing row is found at the same index, merge each cell.
          if (existingSheet.sheetData[rowIndex]) {
            Object.keys(newRow).forEach((key) => {
              // Merge new cell data with existing cell data.
              existingSheet.sheetData[rowIndex][key] = {
                ...existingSheet.sheetData[rowIndex][key],
                ...newRow[key],
              };
            });
          } else {
            // If no existing row, append the new row.
            existingSheet.sheetData.push(newRow);
          }
        });
      } else {
        // If the sheet doesn't exist, add it as a new record.
        state.sheetMemoryData.push({
          sheetName,
          sheetData,
          sheetIndex,
          sheetId,
        });
      }
    },

    //* function to insert a row in sheet memory data at a specific sheet
    insertRowInSheetMemoryData: (state, action) => {
      const { sheetId, rowData, rowIndex } = action.payload;

      // Find the sheet based on its unique sheetId
      const existingSheetIndex = state.sheetMemoryData.findIndex(
        (sheet) => sheet.sheetId === sheetId
      );

      // If the sheet exists, insert the row at the specified index
      if (existingSheetIndex !== -1) {
        const existingSheet = state.sheetMemoryData[existingSheetIndex];

        // If rowIndex is provided and valid, insert the row at that position
        if (
          rowIndex !== undefined &&
          rowIndex >= 0 &&
          rowIndex <= existingSheet.sheetData.length
        ) {
          existingSheet.sheetData.splice(rowIndex, 0, rowData);
        } else {
          // If no valid rowIndex is provided, append the row to the end
          existingSheet.sheetData.push(rowData);
        }
      }
      // If the sheet doesn't exist, do nothing or handle the error case
    },

    //* function to insert a row in sheet memory data at a specific sheet
    // this state is for arranging column headers previously it was Window.ReorderColumnHeaders
    setArrangeListData: (state, action) => {
      state.arrangeListData = action.payload;
    },
    //* this action is used to update column headers in redux
    setColumnHeaders: (state, action) => {
      state.columnHeaders = action.payload;
    },

    //* this action is used to update all sheet data along with style and value which is currently present in sheet in redux
    setAllSheetData: (state, action) => {
      const { sheetName, sheetData, sheetIndex, sheetId } = action.payload;

      // Find the sheet based on its unique sheetId.
      const existingSheetIndex = state.allSheetData.findIndex(
        (sheet) => sheet.sheetId === sheetId
      );

      // If the sheet already exists, merge/update the rows.
      if (existingSheetIndex !== -1) {
        const existingSheet = state.allSheetData[existingSheetIndex];

        // Loop through each row in the incoming sheetData
        sheetData.forEach((newRow, rowIndex) => {
          // If an existing row is found at the same index, merge each cell.
          if (existingSheet.sheetData[rowIndex]) {
            Object.keys(newRow).forEach((key) => {
              // Merge new cell data with existing cell data.
              existingSheet.sheetData[rowIndex][key] = {
                ...existingSheet.sheetData[rowIndex][key],
                ...newRow[key],
              };
            });
          } else {
            // If no existing row, append the new row.
            existingSheet.sheetData.push(newRow);
          }
        });
      } else {
        // If the sheet doesn't exist, add it as a new record.
        state.allSheetData.push({ sheetName, sheetData, sheetIndex, sheetId });
      }
    },
    clearSheetMemoryData: (state) => {
      state.sheetMemoryData = [];
    },
  },
  //* Add extra reducers to handle loading states if needed
  extraReducers: (builder) => {},
});

export const {
  setArrangeListData,
  setColumnHeaders,
  setAllSheetData,
  setSheetMemoryData,
  insertRowInSheetMemoryData,
  clearSheetMemoryData,
} = sheetDataSlice.actions;
export default sheetDataSlice.reducer;
